import { createSlice } from "@reduxjs/toolkit";

const initial = {
  user: null,
  token: null,
  status: "idle",
  error: null,
  // ⬇️ 회원가입 상태만 추가
  signupStatus: "idle",
  signupError: null,
  updateStatus: "idle",
  updateError: null,
  // 비밀번호 찾기
  verifyStatus: "idle",
  verifyError: null,
  resetToken: null,
  resetStatus: "idle",
  resetError: null,
};

const slice = createSlice({
  name: "auth",
  initialState: initial,
  reducers: {
    hydrateFromStorage(s) {
      const t = localStorage.getItem("token");
      const u = localStorage.getItem("user");
      if (t && u) {
        s.token = t;
        s.user = JSON.parse(u);
      }
    },
    loginRequested(s) {
      s.status = "loading";
      s.error = null;
    },
    loginSucceeded(s, a) {
      s.status = "succeeded";
      s.token = a.payload.token;
      s.user = a.payload.user;
    },
    loginFailed(s, a) {
      s.status = "failed";
      s.error = a.payload;
    },
    logout(s) {
      Object.assign(s, initial);
    },

    // ⬇️ 회원가입
    registerRequested(s) {
      s.signupStatus = "loading";
      s.signupError = null;
    },
    registerSucceeded(s) {
      s.signupStatus = "succeeded";
    },
    registerFailed(s, a) {
      s.signupStatus = "failed";
      s.signupError = a.payload;
    },
    updateRequested(s) {
      s.updateStatus = "loading";
      s.updateError = null;
    },
    updateSucceeded(s, a) {
      s.updateStatus = "succeeded";
      if (a.payload?.user) {
        s.user = a.payload.user;
        localStorage.setItem("user", JSON.stringify(a.payload.user));
      }
    },
    updateFailed(s, a) {
      s.updateStatus = "failed";
      s.updateError = a.payload;
    },

    // 비밀번호 찾기
    verifyUserRequested(s) {
      s.verifyStatus = "loading";
      s.verifyError = null;
      s.resetToken = null;
    },
    verifyUserSucceeded(s, a) {
      s.verifyStatus = "succeeded";
      s.resetToken = a.payload; // reset_token string
    },
    verifyUserFailed(s, a) {
      s.verifyStatus = "failed";
      s.verifyError = a.payload;
      s.resetToken = null;
    },
    resetPasswordRequested(s) {
      s.resetStatus = "loading";
      s.resetError = null;
    },
    resetPasswordSucceeded(s) {
      s.resetStatus = "succeeded";
      s.resetToken = null;
    },
    resetPasswordFailed(s, a) {
      s.resetStatus = "failed";
      s.resetError = a.payload;
    },
    findPasswordCleared(s) {
      s.verifyStatus = "idle";
      s.verifyError = null;
      s.resetToken = null;
      s.resetStatus = "idle";
      s.resetError = null;
    },
  },
});

export const {
  hydrateFromStorage,
  loginRequested, loginSucceeded, loginFailed, logout,
  registerRequested, registerSucceeded, registerFailed,
  updateRequested, updateSucceeded, updateFailed,
  verifyUserRequested, verifyUserSucceeded, verifyUserFailed,
  resetPasswordRequested, resetPasswordSucceeded, resetPasswordFailed,
  findPasswordCleared,
} = slice.actions;

export default slice.reducer;
export const selectAuth = (s) => s.auth;
